import { render, staticRenderFns } from "./colorSelect.vue?vue&type=template&id=0f181277&scoped=true"
import script from "./colorSelect.vue?vue&type=script&lang=js"
export * from "./colorSelect.vue?vue&type=script&lang=js"
import style0 from "./colorSelect.vue?vue&type=style&index=0&id=0f181277&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f181277",
  null
  
)

export default component.exports